import Image from "next/image";
import Breadcrumbs from "@components/UI/Breadcrumbs";
import s from "./styles.module.sass";
import starSrc from "../../../../../../public/icons/star.svg";
import { ROUTES } from "../../../../../constants/ROUTES";
import { pluralForm } from "@shared/functions/pluralForm";
import CourseCover from "@shared/UI/CourseCover";
import { useStore } from "effector-react";
import { $reviewsResponse } from "@features/Reviews/model/private";
import { CourseResponse } from "../../../../../services/api/courses/typedef";

const links = [
	{
		id: 0,
		title: "Главная",
		to: ROUTES.MAIN,
	},
	{
		id: 1,
		title: "Курсы",
		to: ROUTES.ALL_COURSES,
	},
];

type MainInfoProps = {
	courseInfo: CourseResponse;
	rating: string;
	author?: {
		firstName: string;
		lastName: string;
	};
};

const MainInfo = ({ courseInfo, rating, author }: MainInfoProps) => {
	const courseReviews = useStore($reviewsResponse);
	const totalReviews = courseReviews?.totalCount || 0;

	const { title, subtitle, coverUrl, teaserUrl, id } = courseInfo;
	// Проверка на undefined, как и сам тип автора в интерфейсе, обусловлены обратной совместимостью.
	// Пока непонятно, какие у них данные. Перестраховаться не помешает.
	// Логично, что автор курса не может быть не найден.
	const formattedAuthor = author !== undefined ? `${author.firstName} ${author.lastName}` : "";

	return (
		<section className={s.mainContentWrapper}>
			<div className={s.content}>
				<div className={s.breadcrumbsWrapper}>
					<Breadcrumbs links={links} currentPage={title} color="secondary" />
				</div>

				<div className={s.courseCoverWrapper}>
					<CourseCover id={id} isFill cover={coverUrl} promo={teaserUrl ?? ""} courseTitle={title} />
				</div>

				<h1 className={s.title}>{title}</h1>
				<p>{subtitle}</p>
				<div className={s.details}>
					<div className={s.testimonials}>
						<p className={s.rating}>
							<Image src={starSrc} width={21} height={21} alt="Рейтинг" />
							{rating}
						</p>
						<p>
							({totalReviews} {pluralForm(totalReviews, "отзыв", "отзыва", "отзывов")})
						</p>
					</div>
					<p>{formattedAuthor}</p>
				</div>
			</div>
		</section>
	);
};

export default MainInfo;
